import { atomFamily, useRecoilState } from 'recoil';
import { recoilPersist } from 'recoil-persist';
import { defaultReportState } from '../../patient/hooks/use-report';
import { Key, ReportStateType } from '../../patient/patient-types';

const { persistAtom } = recoilPersist();

export const AdminPatientSurveyState = atomFamily<ReportStateType, Key | null | undefined>({
  key: 'AdminPatientSurveyState',
  default: defaultReportState,
  effects_UNSTABLE: [persistAtom],
});

export function usePersistSurveyState({ surveyId, aid }: { surveyId?: Key | null; aid?: string | null }) {
  // Athena integration의 경우 aid가 있으면 surveyId와 함께 키로 사용하여 다른 aid마다 별도의 localStorage 사용
  // 일반 설문지의 경우 aid가 없으므로 기존처럼 surveyId만 사용
  const storageKey = aid ? `${surveyId}_aid_${aid}` : surveyId;
  const [persSurveyState, setPersSurveyState] = useRecoilState(AdminPatientSurveyState(storageKey));

  function resetPersState() {
    setPersSurveyState({
      globalAnswerMap: {},
      nextTreeKeys: [],
      presentIllness: [],
      treeStates: [],
      descriptiveReport: undefined,
    });
  }
  return [{ persSurveyState }, { resetPersState, setPersSurveyState }] as const;
}
